
const sendSearchResultViewedEvent = (hitsPerPage) => {

    if (window.aa !== undefined && window.algoliaHits !== undefined) {

        let eventName = 'SRP: Page Viewed';
        if (window.algoliaIsCategoryPage) {
            eventName = 'PLP: Page Viewed';
        }

        if (window.algoliaHits.length > 0) {
            let hits = window.algoliaHits.slice(-parseInt(hitsPerPage));
            let objectIds = [];

            if (ACC.config.algolia.trackingScope === 'multiple') {
                hits.forEach(function (hit) {
                    objectIds = objectIds.concat(hit.connectedObjectIds);
                });
            } else {
                hits.forEach(function (hit) {
                    objectIds.push(hit.objectID);
                });
            }

            sendEvents(eventName, 'view', {}, objectIds, null, {}, null, {});
            storeQueryId(hits.length ? hits[0].__queryID : undefined);
        }
        window.algoliaHits = undefined;
    }
};

const storeQueryId = (queryId) => {
    if (queryId !== undefined) {
        $.ajax({
            url:  window.location.origin + ACC.config.encodedContextPath + '/ajax/storeQueryId?queryId=' + queryId,
            type: 'POST'
        })
    }
}

const sendFilterRangeClickedEvent = (filter, filterValueMin, filterValueMax) => {

    if (window.aa !== undefined) {

        let eventName = 'SRP: Filter Clicked';
        if (window.algoliaIsCategoryPage) {
            eventName = 'PLP: Filter Clicked';
        }

        /*
            not working see https://support.algolia.com/hc/en-us/articles/5552656398353--The-filters-should-be-Facet-Filters-error-in-Events-Debugger
            let filters = [];
            filters.push(filter + '>=' + filterValueMin);
            filters.push(filter + '<=' + filterValueMax);

            aa('clickedFilters', {
                userToken: window.algoliaUserToken,
                index:     ACC.config.algolia.index,
                eventName: eventName,
                filters: filters,
            });
        */

        aa('sendEvents', [
            {
                ...getOptions(),
                eventName: eventName,
                eventType: 'click',
                filters: [filter + ':' + '>=' + filterValueMin]
            },
            {
                ...getOptions(),
                eventName: eventName,
                eventType: 'click',
                filters: [filter + ':' + '<=' + filterValueMax]
            }
        ]);
    }
};

const sendSearchResultClickedEvent = (hit) => {

    if (window.aa !== undefined) {

        let eventName = 'SRP: Product Clicked';
        if (window.algoliaIsCategoryPage) {
            eventName = 'PLP: Product Clicked';
        }

        let objectIds = null;
        if (ACC.config.algolia.trackingScope === 'multiple') {
            objectIds = hit.connectedObjectIds;
        } else {
            objectIds = [hit.objectID];
        }

        let positions = [];
        objectIds.forEach(function () {
            positions.push(hit.__position);
        });

        sendEvents(eventName, 'click', {queryID: hit.__queryID}, objectIds, positions, {}, null, {});
    }
};

const sendSearchResultThumbClickedEvent = (queryID, connectedObjectIds, position) => {

    if (window.aa !== undefined) {

        let eventName = 'SRP: Product Clicked';
        if (window.algoliaIsCategoryPage) {
            eventName = 'PLP: Product Clicked';
        }

        let connectedObjectIdsArray = connectedObjectIds.split(',');

        let objectIds = null;
        if (ACC.config.algolia.trackingScope === 'multiple') {
            objectIds = connectedObjectIdsArray;
        } else {
            objectIds = connectedObjectIdsArray.slice(1);
        }

        let positions = [];
        objectIds.forEach(function (id) {
            positions.push(parseInt(position));
        });

        sendEvents(eventName, 'click', {queryID: queryID}, objectIds, positions, {}, null, {});
    }
};

const sendAddToWishlistClickedEvent = (queryID, objectID, connectedObjectIds) => {

    if (window.aa !== undefined) {

        let eventName = 'SRP: Product Added to Wishlist';
        if (window.algoliaIsCategoryPage) {
            eventName = 'PLP: Product Added to Wishlist';
        }

        let objectIds = null;
        if (ACC.config.algolia.trackingScope === 'multiple') {
            objectIds = connectedObjectIds.split(',');
        } else {
            objectIds = [objectID];
        }

        sendEvents(eventName, 'conversion', {queryID: queryID}, objectIds, null, {}, null, {});
    }
};

const sendPdpViewedClickedEvent = (objectID, connectedObjectIds) => {

    if (window.aa !== undefined) {

        let objectIds = null;
        if (ACC.config.algolia.trackingScope === 'multiple') {
            objectIds = connectedObjectIds;
        } else {
            objectIds = [objectID];
        }

        sendEvents('PDP: Product Viewed', 'view', {}, objectIds, null, {}, null, {});
    }
};

const sendPdpAddToWishlistClickedEvent = (queryID, objectID, connectedObjectIds) => {

    if (window.aa !== undefined) {
        let eventName = 'PDP: Product Added to Wishlist after search';
        let queryIDValue = {queryID: queryID};
        if (queryID === '') {
            eventName = 'PDP: Product Added to Wishlist';
            queryIDValue = {};
        }

        let objectIds = null;
        if (ACC.config.algolia.trackingScope === 'multiple') {
            objectIds = connectedObjectIds;
        } else {
            objectIds = [objectID];
        }

        sendEvents(eventName, 'conversion', queryIDValue, objectIds, null, {}, null, {});
    }
};

const sendPdpAddToCartClickedEvent = (queryID, objectID, qty, price) => {

    if (window.aa !== undefined) {

        let eventName = 'PDP: Product Added to Cart after search';
        let queryIDValue = {queryID: queryID};
        if (queryID === '') {
            eventName = 'PDP: Product Added to Cart';
            queryIDValue = {};
        }

        let currencyValue = {currency: $("main").attr('data-currency-iso-code')}

        let objectIds = [objectID];
        let objectData = [{price: price, quantity: qty}];

        sendEvents(eventName, 'conversion', queryIDValue, objectIds, null, currencyValue, objectData, {eventSubtype: 'addToCart'});
    }
};

const sendPurchaseEvent = () => {

    if (window.aa !== undefined) {

        if(window.orderObjectData !== undefined) {

            let currencyValue = {currency: $("main").attr('data-currency-iso-code')};
            let entries = window.orderObjectData.entries;

            const entryGroups = entries.reduce((acc, item) => {
                let queryIdTemp = item.queryID === '' ? 'empty' : item.queryID;
                if (!acc[queryIdTemp]) {
                    acc[queryIdTemp] = [];
                }

                acc[queryIdTemp].push(item);
                return acc;
            }, {})

            Object.entries(entryGroups).forEach(idEntry => {
                let objectIds = [];
                let objectData = [];
                let queryID = '';
                let queryIDTimestamp = 0;

                const [key, value] = idEntry;
                if(key !== 'empty') {
                    queryID = key;
                    queryIDTimestamp = value[0].queryIDTimestamp;
                }

                value.forEach((entry) => {
                    objectIds.push(entry.code);
                    objectData.push({price: entry.price, quantity: entry.qty});
                });

                let eventName = 'Checkout after search';
                let queryIDValue = {queryID: queryID};
                let queryIDTimestampValue = (queryIDTimestamp > 0) ? {timestamp: queryIDTimestamp} : {};
                if (queryID === '') {
                    eventName = 'Checkout';
                    queryIDValue = {};
                    queryIDTimestampValue = {};
                }
                sendEvents(eventName, 'conversion', queryIDValue, objectIds, null, currencyValue, objectData, {eventSubtype: 'purchase'}, queryIDTimestampValue);
            });
        }
    }
};

const getOptions = () => {

    let options = {
        userToken: window.algoliaUserToken,
        index: ACC.config.algolia.index
    };
    if (window.algoliaPersonalization && window.algoliaEncodedEmail !== '') {
        options = {
            ...options,
            authenticatedUserToken: window.algoliaEncodedEmail
        };
    }
    return options;
}

const sendEvents = (eventName, eventType, queryIDValue, objectIds, positions, currencyValue, objectData, eventSubTypeValue, queryIDTimestampValue) => {
    let events = [];
    let splitSize = 20;
    for (let i = 0; i < objectIds.length; i += splitSize) {
        let positionsValue = {};
        const objectIdsChunk = objectIds.slice(i, i + splitSize);
        if (positions !== null) {
            positionsValue = {positions: positions.slice(i, i + splitSize)};
        }
        let objectDataValue = {};
        if (objectData !== null) {
            objectDataValue = {objectData: objectData.slice(i, i + splitSize)};
        }
        let event = {
            ...getOptions(),
            eventName: eventName,
            eventType: eventType,
            ...eventSubTypeValue,
            ...queryIDValue,
            ...queryIDTimestampValue,
            objectIDs: objectIdsChunk,
            ...positionsValue,
            ...currencyValue,
            ...objectDataValue
        }
        events.push(event);
    }

    aa('sendEvents', events);
}

export {
    sendFilterRangeClickedEvent,
    sendSearchResultViewedEvent,
    sendSearchResultClickedEvent,
    sendSearchResultThumbClickedEvent,
    sendAddToWishlistClickedEvent,
    sendPdpViewedClickedEvent,
    sendPdpAddToWishlistClickedEvent,
    sendPdpAddToCartClickedEvent,
    sendPurchaseEvent
};


